<br><br>
<div class="card">
    <ng-container *ngIf="dataOfPhysicalVerMIDone">
        <div class="print border bold">
            <h4 style="display: inline">Field Verification data from JE:{{dataOfPhysicalVerMIDone.ProgramName}}</h4>
            <h4 style="display: inline;margin-left:20px;">Date of Verified:{{dataOfPhysicalVerMIDone.JEActionDate}}</h4>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>Name of Vendor</th>
                    <th>Farmer Registration No.</th>
                    <th>District</th>
                </tr>
                <tr>
                    <td>{{dataOfPhysicalVerMIDone.VendorName}}</td>
                    <td>{{dataOfPhysicalVerMIDone.AppID}}</td>
                    <td>{{dataOfPhysicalVerMIDone.District}}</td>
                </tr>
            </table>
        </div>
    </ng-container>
    <!-- Field Verification data details end -->
    <br><br>

    <!-- Physical Verification details start -->
    <ng-container *ngIf="dataOfPhysicalVerMIDone || dataOfPhysicalVerMIDone?.listDataForPhysicalVer.length>0">
        <div class="print border bold">
            <h4>Physical Verification</h4>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>SrNo.</th>
                    <th>Component</th>
                    <th>Quantity</th>
                    <th>Size</th>
                    <th>Price</th>
                    <th>Subsidy Amount</th>
                    <th>Farmer App Status</th>
                </tr>

                <tr *ngFor="let row of dataOfPhysicalVerMIDone?.listDataForPhysicalVer;let i=index">
                    <td>{{i+1}}</td>
                    <td>{{row.component}}</td>
                    <td>{{row.EstimatedQuantity}}</td>
                    <td>{{row.size}}</td>
                    <td>{{row.Price}}</td>
                    <td>{{dataOfPhysicalVerMIDone.SubsidyToFarmerAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.FarmerAppStatus}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td><b>Total</b></td>
                    <td></td>
                    <td></td>
                    <td>{{totalPrice}}</td>
                    <td>{{totalSubsidyAmount}}</td>
                    <td></td>
                </tr>

            </table>
        </div>
    </ng-container>
    <!-- Physical Verification details end -->
    <br><br>

    <!-- Vendor BOQ details start -->
    <ng-container *ngIf="dataOfPhysicalVerMIDone || dataOfPhysicalVerMIDone?.listDataForPhysicalVer.length>0">
        <div class="print border bold">
            <h4>Vendor BOQ </h4>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>SrNo.</th>
                    <th>Component</th>
                    <th>Quantity</th>
                    <th>Size</th>
                    <th>Price</th>
                    <th>Subsidy Amount</th>
                    <th>Farmer Share</th>
                </tr>
                <tr *ngFor="let row of dataOfPhysicalVerMIDone?.listDataForPhysicalVer;let i=index">
                    <td>{{i+1}}</td>
                    <td>{{row.component}}</td>
                    <td>{{row.EstimatedQuantity}}</td>
                    <td>{{row.size}}</td>
                    <td>{{row.Price}}</td>
                    <td>{{dataOfPhysicalVerMIDone.SubsidyToFarmerAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.FarmerShareAmount}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td><b>Total</b></td>
                    <td></td>
                    <td></td>
                    <td>{{totalPrice}}</td>
                    <td>{{totalSubsidyAmount}}</td>
                    <td>{{totalFarmerShare}}</td>
                </tr>
            </table>
        </div>
    </ng-container>
    <!-- Vendor BOQ details end -->
    <br><br>

    <!--Vendor Estimate details start  -->
    <ng-container *ngIf="dataOfPhysicalVerMIDone || dataOfPhysicalVerMIDone?.listDataForPhysicalVer.length>0">
        <div class="print border bold">
            <h4>Vendor Estimate</h4>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>SrNo.</th>
                    <th>Component</th>
                    <th>Quantity</th>
                    <th>Size</th>
                    <th>Price</th>
                    <th>Subsidy Amount</th>
                    <th>Farmer Share</th>
                    <th>Farmer App Status</th>
                    <th>Farmer Vendor Status</th>
                </tr>
                <tr *ngFor="let row of dataOfPhysicalVerMIDone?.listDataForPhysicalVer;let i=index">
                    <td>{{i+1}}</td>
                    <td>{{row.component}}</td>
                    <td>{{row.EstimatedQuantity}}</td>
                    <td>{{row.size}}</td>
                    <td>{{row.Price}}</td>
                    <td>{{dataOfPhysicalVerMIDone.SubsidyToFarmerAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.FarmerShareAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.farmerAppStatus}}</td>
                    <td>{{dataOfPhysicalVerMIDone.farmerVendorStatus}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td><b>Total</b></td>
                    <td></td>
                    <td></td>
                    <td>{{totalPrice}}</td>
                    <td>{{totalSubsidyAmount}}</td>
                    <td>{{totalFarmerShare}}</td>
                    <td></td>
                    <td></td>
                </tr>
            </table>
        </div>

    </ng-container>
    <!-- Vendor Estimate details end -->
    <br><br>

    <!--Bill Uploaded By Vendor details start  -->
    <ng-container *ngIf="dataOfPhysicalVerMIDone">
        <div class="print border bold">
            <h4>Bill Uploaded By Vendor</h4>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>View Bill Uploaded</th>
                </tr>
                <!-- <tr  *ngFor="let data of dataOfPhysicalVerMIDone">
          <td>{{data.viewBillUpload}}</td>
        </tr> -->
                <tr *ngIf="dataOfPhysicalVerMIDone">
                    <th><a href="{{dataOfPhysicalVerMIDone.VendorBillBoq}}">view</a></th>
                </tr>
            </table>
        </div>
        <br>
        <div class="table">
            <table class="border">
                <tr>
                    <th>Total Amount of Component</th>
                    <th>Amount of Fitting & Accessories</th>
                    <th>Sub-Total</th>
                    <th>Farmer Share</th>
                    <th>Farmer Share Deposited</th>
                </tr>
                <tr>
                    <td>{{dataOfPhysicalVerMIDone.PhyVerTotalComponentAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.PhyVerBilledTransportAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.PhyVerTotalComponentAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.FarmerShareAmount}}</td>
                    <td>{{dataOfPhysicalVerMIDone.AmtPaidByFarmer}}</td>
                </tr>
            </table>
        </div>
        <div class="table">
            <table class="border">
                <tr>
                    <th>Area(in acre) MI to be Installed</th>
                    <th>Plant Spacing (in mtr)</th>
                    <th>Crop Name</th>
                    <th>Remarks by JE/AI</th>
                </tr>
                <tr>
                    <td>{{dataOfPhysicalVerMIDone.MIArea}}</td>
                    <td>{{dataOfPhysicalVerMIDone.PlantSpacing}}</td>
                    <td>{{dataOfPhysicalVerMIDone.CropName}}</td>
                    <td>{{dataOfPhysicalVerMIDone.JERemarks}}</td>
                </tr>
            </table>
        </div>
    </ng-container>
    <!-- Bill Uploaded By Vendor details start -->
</div>